import React from "react"
import style from "./button.module.scss"
function ColorFullButton({ text, otherClassName }) {
  return <button className={`${style.button} ${otherClassName}`}>{text}</button>
}

export default ColorFullButton
